export const appleSendStyleBubbleSlam = "com.apple.MobileSMS.expressivesend.impact";
export const appleSendStyleBubbleLoud = "com.apple.MobileSMS.expressivesend.loud";
export const appleSendStyleBubbleGentle = "com.apple.MobileSMS.expressivesend.gentle";
export const appleSendStyleBubbleInvisibleInk = "com.apple.MobileSMS.expressivesend.invisibleink";
export const appleSendStyleScrnEcho = "com.apple.messages.effect.CKEchoEffect";
export const appleSendStyleScrnSpotlight = "com.apple.messages.effect.CKSpotlightEffect";
export const appleSendStyleScrnBalloons = "com.apple.messages.effect.CKHappyBirthdayEffect";
export const appleSendStyleScrnConfetti = "com.apple.messages.effect.CKConfettiEffect";
export const appleSendStyleScrnLove = "com.apple.messages.effect.CKHeartEffect";
export const appleSendStyleScrnLasers = "com.apple.messages.effect.CKLasersEffect";
export const appleSendStyleScrnFireworks = "com.apple.messages.effect.CKFireworksEffect";
export const appleSendStyleScrnShootingStar = "com.apple.messages.effect.CKShootingStarEffect";
export const appleSendStyleScrnCelebration = "com.apple.messages.effect.CKSparklesEffect";

export const appleServiceAppleMessage = "iMessage";
export const appleServiceTextMessageForwarding = "SMS";